function writeFogUbo(data, scene) {
  const fog = scene.fog;
  if (fog) {
    data[80] = fog.mode;
    data[81] = fog.start;
    data[82] = fog.end;
    data[83] = fog.density;
    data[84] = fog.color[0];
    data[85] = fog.color[1];
    data[86] = fog.color[2];
  }
}
function writeClipPlaneUbo(data, scene) {
  const clipPlane = scene.clipPlane;
  if (clipPlane) {
    data[88] = clipPlane[0];
    data[89] = clipPlane[1];
    data[90] = clipPlane[2];
    data[91] = clipPlane[3];
  }
}
function writeEnvUbo(data, scene) {
  data[36] = scene._environmentRotation ?? 0;
  const sh = scene._envTextures?.sphericalHarmonics;
  if (sh) {
    data.set(sh, 40);
  }
}
function _registerSceneUboContributor(scene, contributor) {
  const list = scene._sceneUboContributors ??= [];
  if (!list.includes(contributor)) {
    list.push(contributor);
  }
}
function _invalidateSceneUboCaches(scene) {
  for (const task of scene._frameGraph._tasks) {
    if (task._sceneUboCacheKey) {
      task._sceneUboCacheKey.length = 0;
    }
  }
}
function setFog(scene, config) {
  scene.fog = config;
  _registerSceneUboContributor(scene, writeFogUbo);
}
function setClipPlane(scene, plane) {
  scene.clipPlane = plane;
  _registerSceneUboContributor(scene, writeClipPlaneUbo);
}
function registerEnvSceneUniforms(scene) {
  _registerSceneUboContributor(scene, writeEnvUbo);
}

export { _invalidateSceneUboCaches, _registerSceneUboContributor, registerEnvSceneUniforms, setClipPlane, setFog };
//# sourceMappingURL=scene-ubo-extras.js.map
